// extracted by mini-css-extract-plugin
module.exports = {"userBadge":"UserBadge_userBadge__13oen","fadeIn":"UserBadge_fadeIn__31GR6","fadeOut":"UserBadge_fadeOut__D5qqK"};